import { render, staticRenderFns } from "./VagaDetalhes.vue?vue&type=template&id=31cfe0c4"
import script from "./VagaDetalhes.vue?vue&type=script&lang=js"
export * from "./VagaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports